module.exports = __webpack_public_path__ + "static/media/furniture-sc.379b4408.svg";